// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.securite-page {
  font-family: Arial, sans-serif;
  line-height: 1.6;
  width: 100%;
  padding: 2rem;
  margin: 0 !important;
}

.securite-title-h1 {
  color: #f97316;
}

.securite-title-h2 {
  color: #f97316;
}

.securite-title-h3 {
  color: #f97316;
}

.securite-title-h4 {
  color: #f97316;
}

.securite-custom-container {
  max-width: inherit !important;
  margin: 0 !important;
}

.securite-custom-paragraph {
  margin-bottom: 1em;
}

.securite-custom-ul {
  list-style-type: disc;
  margin-left: 20px;
  margin-bottom: 1em;
}

.securite-custom-title-h1 {
  color: #f97316;
}

.securite-custom-title-h2 {
  color: #f97316;
}

.securite-custom-title-h3 {
  color: #f97316;
}

.securite-custom-title-h4 {
  color: #f97316;
  margin-top: 1em;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Securite/Securite.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB","sourcesContent":[".securite-page {\n  font-family: Arial, sans-serif;\n  line-height: 1.6;\n  width: 100%;\n  padding: 2rem;\n  margin: 0 !important;\n}\n\n.securite-title-h1 {\n  color: #f97316;\n}\n\n.securite-title-h2 {\n  color: #f97316;\n}\n\n.securite-title-h3 {\n  color: #f97316;\n}\n\n.securite-title-h4 {\n  color: #f97316;\n}\n\n.securite-custom-container {\n  max-width: inherit !important;\n  margin: 0 !important;\n}\n\n.securite-custom-paragraph {\n  margin-bottom: 1em;\n}\n\n.securite-custom-ul {\n  list-style-type: disc;\n  margin-left: 20px;\n  margin-bottom: 1em;\n}\n\n.securite-custom-title-h1 {\n  color: #f97316;\n}\n\n.securite-custom-title-h2 {\n  color: #f97316;\n}\n\n.securite-custom-title-h3 {\n  color: #f97316;\n}\n\n.securite-custom-title-h4 {\n  color: #f97316;\n  margin-top: 1em;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
